export function staticFilesRuntimeUrl(filePath: string) {
  return `${filePath}`
}
